/**
 * SaleFormBotica.jsx
 * ─────────────────────────────────────────────────────────────────────────────
 * POS especializado para BOTICA / FARMACIA.
 * Reutiliza SaleForm y garantiza que el modo botica esté activo,
 * independientemente de lo que diga el localStorage (útil para demos o
 * cuando el tipo de negocio está recién seteado y el JWT no se recargó).
 * ─────────────────────────────────────────────────────────────────────────────
 */
import React from 'react';
import SaleForm from './SaleForm';

/**
 * SaleFormBotica — wrapper de SaleForm para negocios tipo botica.
 * Inyecta las props necesarias para activar modo farmacia.
 */
const SaleFormBotica = ({ onSaleSuccess, onShowHistory }) => {
    return (
        <SaleForm
            onSaleSuccess={onSaleSuccess}
            onShowHistory={onShowHistory}
            forceTipoNegocio="botica"
        />
    );
};

export default SaleFormBotica;
